import Checkout from '../../components/checkout/checkout.vue';
import CheckoutStripe from '../../components/checkout/checkout-stripe.vue';
import ThankYou from '../../components/checkout/thank-you.vue';

export default {
    path: '/checkout',
    component: {
        render (c) {
            return c('router-view')
        },
    },
    children: [
        {
            path: '',
            name: 'checkout',
            component: Checkout,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: 'stripe',
            name: 'checkout-stripe',
            component: CheckoutStripe,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: 'shopify',
            name: 'checkout-shopify',
            component: Checkout,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: 'thank-you',
            name: 'checkout-thank-you',
            component: ThankYou,
            meta: {
                requiresAuth: true
            }
        },
    ],
};